<script>
	import SignUp from './SignUp.svelte';

	let dialogOpened = false;
</script>

<section>
	<img class="logo" src="./images/menoage.svg" alt="MenoAge logo" height="40">
	<h1>You can’t avoid it, but you can <em>take control</em> of it.</h1>
	<p>MenoAge is a unique blood test that can be used to identify <strong>perimenopause and menopause</strong>, guide therapy and manage future disease risk. Sign up for free and get notified first when it becomes available.</p>
	<button on:click={() => dialogOpened = true}>Tell me when it launches</button>
	<img class="hero" src="./images/hero.svg" alt="Diverse women standing together">
</section>

<SignUp bind:showing={dialogOpened}/>

<style>
	section {
		padding: 2rem 2rem 0;
		text-align: center;
		background: var(--bg-2);
	}

	.logo {
		height: 2rem;
		width: auto;
		margin: auto;
		display: block;
	}

	h1 {
		max-width: 18ch;
		margin: 2rem auto;
		font-size: calc(2rem + 1vw);
		font-family: var(--ff-2);
		font-weight: normal;
	}

	em {
		font-style: normal;
		text-decoration: underline;
	}

	p {
		margin: 0 auto 2rem;
		max-width: 52ch;
		font-size: 1.125rem;
	}

	strong {
		background: #B4B2F9;
    font-weight: normal;
	}

	button {
    border: none;
    border-radius: .5rem;
    padding: 1rem 2rem;
    background: var(--a1-b);
    color: var(--a1-c);
    font-weight: bold;
    font-size: 1.25rem;
    font-family: var(--ff-1);
    cursor: pointer;
    transition: .2s;
  }

  button:is(:hover,:focus) {
    box-shadow: .25rem .25rem 1px var(--fg-1);
  }

	.hero {
		display: block;
		margin: 4rem -2rem 0;
	}
</style>